import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { EncryptService } from '../../services/encrypt/encrypt.service';
import { ConfigService } from 'src/app/services/config/config.service';



@Injectable({
  providedIn: 'root',
})
export class LoginService {
  //private loat_web_backend_login = endpoints.loat_web_backend + endpoints.login;

  private loat_web_backend_login = this.configService.login;

  constructor(
    private httpclient: HttpClient,
    private cryptservice: EncryptService,
    private configService: ConfigService
  ) {}

  public login(user, password) {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
    return this.httpclient
      .post<any>(
        this.loat_web_backend_login,
        { username: user, password: this.cryptservice.encrypt(password), overthrone: 'false'},
        { headers: headers }
      )
  }

  public forcedLogin(user, password) {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/json; charset=utf-8'
    );
    return this.httpclient
      .post<any>(
        this.loat_web_backend_login,
        { username: user, password: this.cryptservice.encrypt(password), overthrone: 'true'},
        { headers: headers }
      )
  }
}
